import { AlertCircle, Loader2, Save } from "lucide-react"

import { Alert, AlertDescription } from "shared/ui/alert"
import { Button } from "shared/ui/button"
import { Card, CardContent } from "shared/ui/card"

export function EditorErrorAlert({ message }: { message: string }) {
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  )
}

export function EditorLoadingCard() {
  return (
    <Card>
      <CardContent className="h-56 flex items-center justify-center text-gray-500">
        <div className="inline-flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          Loading template...
        </div>
      </CardContent>
    </Card>
  )
}

export function EditorNotFoundCard() {
  return (
    <Card>
      <CardContent className="h-40 flex items-center text-gray-500">Template not found.</CardContent>
    </Card>
  )
}

export function FloatingSaveButton({
  onSave,
  isSaving,
}: {
  onSave: () => void
  isSaving: boolean
}) {
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <Button onClick={onSave} disabled={isSaving} className="gap-2 shadow-lg">
        {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        Save
      </Button>
    </div>
  )
}

